import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@/auth/AuthContext'

export const Route = createFileRoute('/dashboard/')({ component: DashboardPage })

function DashboardPage() {
  let { company } = useAuth()

  return (
    <div class='container' style={{ display: 'flex', alignItems: 'center', 'justifyContent': 'center', height: '100%' }}>
      <h1 style={{ margin: 0 }}>За дело!</h1>
    </div>
  )
}
